import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Card from '../../../components/ui/Card';

const SqftRevenueChart = ({ analytics }) => {
  return (
    <Card className="p-6 mb-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground mb-2">Revenue Per Sqft by Center</h2>
        <p className="text-sm text-muted-foreground">
          Comparative analysis of revenue efficiency across centers
        </p>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={analytics}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="centerId" stroke="#6b7280" />
          <YAxis stroke="#6b7280" tickFormatter={(value) => `₹${value}`} />
          <Tooltip
            formatter={(value) => `₹${value?.toFixed(2)}`}
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Bar dataKey="revenuePerSqft" fill="#1877F2" name="Revenue per Sqft" />
        </BarChart>
      </ResponsiveContainer>

      <div className="mt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Center Details</h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-foreground">Center</th>
                <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Total Sqft</th>
                <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Occupied</th>
                <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Utilization</th>
                <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Revenue/Sqft</th>
                <th className="px-4 py-3 text-right text-sm font-semibold text-foreground">Total Revenue</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {analytics?.map((center, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium text-foreground">{center?.centerId}</td>
                  <td className="px-4 py-3 text-sm text-right text-muted-foreground">
                    {center?.totalSqft?.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-sm text-right text-muted-foreground">
                    {center?.occupiedSqft?.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 text-sm text-right">
                    <span
                      className={`font-medium ${
                        center?.utilizationRate >= 80
                          ? 'text-green-600'
                          : center?.utilizationRate >= 60
                          ? 'text-yellow-600' :'text-red-600'
                      }`}
                    >
                      {center?.utilizationRate?.toFixed(1)}%
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-right font-semibold text-foreground">
                    ₹{center?.revenuePerSqft?.toFixed(2)}
                  </td>
                  <td className="px-4 py-3 text-sm text-right font-semibold text-foreground">
                    ₹{center?.totalRevenue?.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
};

export default SqftRevenueChart;